export default __webpack_public_path__ + "static/media/mountain-3.22e72420.png";